// extracted by mini-css-extract-plugin
module.exports = {"hoursTable":"az_Gsc","todayRow":"az_Hsc","timeCell":"az_Isc","holidayLabel":"az_Jsc","holidayTime":"az_Ksc","closedText":"az_Lsc"};